import { useRef, useCallback } from "react";
import { useVoiceRecorderStore } from "./voice-message";

export function useModalWithVoiceGuard() {
  const selectedActionRef = useRef<(() => void) | null>(null);

  const checkAndOpen = useCallback((action: () => void, setModalType: (type: "recording" | "voiceBlob" | null) => void, setShowModal: (show: boolean) => void) => {
    const { recording, voiceBlob } = useVoiceRecorderStore.getState();

    if (!recording && !voiceBlob) {
      action();
      return;
    }

    selectedActionRef.current = action;

    if (recording) {
      setModalType("recording");
      setShowModal(true);
      return;
    }

    if (voiceBlob) {
      setModalType("voiceBlob");
      setShowModal(true);
      return;
    }
  }, []);

  const runDeferred = useCallback(() => {
    if (selectedActionRef.current) {
      selectedActionRef.current();
      selectedActionRef.current = null;
    }
  }, []);

  return { checkAndOpen, runDeferred };
}
